'use client';

import clsx from 'clsx';
import Checkbox from '@publishing/components/forms/checkbox/Checkbox';
import s from './PurposeGroup.module.scss';

export const DOWNLOAD_PURPOSE_OPTIONS = ['정보획득', '상담희망'] as const;
export type DownloadPurpose = (typeof DOWNLOAD_PURPOSE_OPTIONS)[number];

const DEFAULT_OPTIONS: PurposeOption[] = [
  { value: '정보획득', label: '정보 획득' },
  { value: '상담희망', label: '상담 희망' },
];

type PurposeOption = {
  value: string;
  label: string;
};

type PurposeGroupProps = {
  label?: string;
  value: string[];
  onChange: (next: string[]) => void;
  /** 선택지. default = 정보 획득 / 상담 희망 */
  options?: PurposeOption[];
  required?: boolean;
  className?: string;
};

export default function PurposeGroup({
  label = '인증 목적 (중복 선택 가능)',
  value,
  onChange,
  options = DEFAULT_OPTIONS,
  required = true,
  className,
}: PurposeGroupProps) {
  const toggle = (option: string) => {
    onChange(
      value.includes(option)
        ? value.filter((v) => v !== option)
        : [...value, option],
    );
  };

  return (
    <div className={clsx(s.root, className)}>
      <div className={s.label_row}>
        <span className={s.label}>{label}</span>
        {required && <span className={s.required_dot} />}
      </div>
      <div className={s.options}>
        {options.map((option) => (
          <Checkbox
            key={option.value}
            label={option.label}
            checked={value.includes(option.value)}
            onChange={() => toggle(option.value)}
            size="md"
            labelClassName={s.checkbox_label}
          />
        ))}
      </div>
    </div>
  );
}
